import { supabase } from './supabase';

export type TrackEvent =
  | 'point_created'
  | 'attendance_set'
  | 'discovery_open'
  | 'chat_open'
  | 'trade_card_sent'
  | 'trade_card_confirmed'
  | 'trade_completed'
  | 'account_reset'
  | 'duplicates_reset';

export async function track(
  name: TrackEvent,
  payload: Record<string, unknown> = {}
): Promise<void> {
  try {
    const { data } = await supabase.auth.getUser();
    const user = data.user;
    if (!user) return;
    await supabase.from('telemetry_events').insert({
      user_id: user.id,
      event_name: name,
      payload,
    });
  } catch (err) {
    if (typeof console !== 'undefined') {
      console.warn('track failed', name, err);
    }
  }
}
